import React, { Component } from 'react';
import ProjectsEditLayout from '../../templates/projects';
import ProjectExpensesEditForm from '../../elements/projects/expenses';
import Loading from "../../elements/loading";

class ProjectEdit extends Component {
	render (){
		const {projects} = this.props;
		return (
			projects.isFetching ? <Loading message="Cargando..." />:<ProjectExpensesEditForm {...this.props}/>
		);
	}

	componentWillMount() {
		this.props.fetchProjectsExpensesEdit(this.props.match.params.id);
	}
}

export default ProjectsEditLayout(ProjectEdit, {subnav: 3});



// WEBPACK FOOTER //
// ./src/layouts/projects/expenses.jsx